module.exports = __webpack_public_path__ + "img/vsys_supernodes.5b3f02a6.png";